var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-cascader',{attrs:{"expandTrigger":"hover","allowClear":false,"value":_vm.getValueSting,"disabled":_vm.disabled,"changeOnSelect":_vm.changeOnSelect,"options":_vm.options,"placeholder":_vm.placeholder},on:{"change":_vm.changeXzc}})}
var staticRenderFns = []

export { render, staticRenderFns }